export const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={12} height={13} fill="none">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M.866 2.869 6 6.549l5.134-3.68a.704.704 0 0 0-.669-.512h-8.93a.704.704 0 0 0-.669.512Zm10.297 1.026L6.24 7.423a.41.41 0 0 1-.48 0L.837 3.895v6.034a.71.71 0 0 0 .698.714h8.93a.71.71 0 0 0 .698-.714V3.895ZM0 3.07C0 2.206.69 1.5 1.535 1.5h8.93C11.31 1.5 12 2.206 12 3.071V9.93c0 .865-.69 1.571-1.535 1.571h-8.93C.69 11.5 0 10.794 0 9.929V3.07Z"
      clipRule="evenodd"
    />
  </svg>
);
